import _get from "lodash/get";
export var getCurrentMortgageRates = function getCurrentMortgageRates(identity) {
  return _get(identity, 'mortgages.currentRates');
};